import React from 'react';

import { Box, Button, Paper, Stack, Typography } from '@mui/material';

interface Props {
  icon: React.ReactNode;
  iconColor: string;
  title: string;
  actionLabel?: string;
  hasViewAll?: boolean;
  children?: React.ReactNode;
}

export default function CaseRelatedCard({ icon, iconColor, title, actionLabel, hasViewAll, children }: Props) {
  return (
    <Paper variant="outlined">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 1.5, bgcolor: 'action.hover' }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: 0.5,
              bgcolor: iconColor,
              color: 'common.white',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            {icon}
          </Box>
          <Typography variant="subtitle2" component="h3" fontWeight="bold">
            {title}
          </Typography>
        </Stack>
        {actionLabel && (
          <Button size="small" variant="outlined" disabled sx={{ textTransform: 'none' }}>
            {actionLabel}
          </Button>
        )}
      </Stack>
      {children}
      {hasViewAll && (
        <Box sx={{ textAlign: 'center', py: 1, borderTop: 1, borderColor: 'divider' }}>
          <Button size="small" disabled sx={{ textTransform: 'none' }}>
            View All
          </Button>
        </Box>
      )}
    </Paper>
  );
}
